<template>
    <div class="ezu-header">
        <div class="ezu-wrap">
            <div class="ezu-container">
                <div class="ezu-flex-container">
                    <div>
                        <a href="/" style="padding-left: 0;">
                            <img src="@/assets/img/logo.png">
                        </a>
                    </div>
                    <nav class="nav-container">
                        <div class="flex-item">
                            <router-link to="/">
                                <span ref="index">首页</span>
                            </router-link>
                        </div>
                        <div class="flex-item">
                            <router-link to="/special" >
                                <span ref="special">e族快车</span>
                            </router-link>
                        </div>
<!--                        <div class="flex-item">-->
<!--                            <router-link to="/green">-->
<!--                                <span  ref="green">公务用车</span>-->
<!--                            </router-link>-->
<!--                        </div>-->
                        <div class="flex-item">
                            <router-link to="/help">
                                <span ref="help">e族帮忙</span>
                            </router-link>
                        </div>
                        <div class="flex-item">
                            <router-link to="/recruit">
                                <span ref="recruit">司机招募</span>
                            </router-link>
                        </div>
                        <div class="flex-item">
                            <router-link to="/about">
                                <span ref="about">关于我们</span>
                            </router-link>
                        </div>
                    </nav>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'ezuTopMenu',
        watch: {
            $route(to, from){
                console.log(to)
                console.log(from)
                this.$refs[to.name].style.color = '#2674BE'
                if(null != from.name){
                    this.$refs[from.name].style.color = '#000000'
                }
            }
        }
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
    }
    a {
        padding: 0 1.5625vw;
        font-size: 1.0416vw;
        line-height: 1.4583vw;
        display: inline-block;
        color: #000000;
        text-decoration: none!important;
        cursor: pointer;
        outline: none;
    }
    .ezu-header {
        position: fixed;
        width: 100%;
        /*z-index: 9;*/
        background-color: #ffffff;
        z-index: 3;
    }
    .ezu-container {
        /*width: 1200px;*/
        width: 62.5vw;
        margin: 0 auto;
        /*background-color: #9c9c9c;*/
    }
    .ezu-flex-container {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .nav-container {
        width: 41.689vw;
        display: flex;
        justify-content: flex-end;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/ezuTopMenu.vue